module.exports = __webpack_public_path__ + "img/kort-22.c91f84a7.jpg";